type WodRxLoads = Record<string, string>;

function isPlainObject(value: unknown): value is Record<string, unknown> {
  return !!value && typeof value === 'object' && !Array.isArray(value);
}

export function getWodRxLoads(methodMeta: unknown): WodRxLoads {
  if (!isPlainObject(methodMeta)) return {};
  const raw = methodMeta.wodRxLoads;
  if (!isPlainObject(raw)) return {};

  const next: WodRxLoads = {};
  for (const [key, value] of Object.entries(raw)) {
    const id = String(key ?? '').trim();
    const label = String(value ?? '').trim();
    if (!id || !label) continue;
    next[id] = label;
  }
  return next;
}

export function getWodRxNote(methodMeta: unknown): string | null {
  if (!isPlainObject(methodMeta)) return null;
  const value = String(methodMeta.wodRxNote ?? '').trim();
  return value || null;
}

export function getWodRxForExercise(
  methodMeta: unknown,
  exerciseId?: string | null
): string | null {
  const id = String(exerciseId ?? '').trim();
  if (!id) return null;
  return getWodRxLoads(methodMeta)[id] ?? null;
}

export function getWodRxSummary(args: {
  methodMeta?: unknown;
  exerciseIds?: Array<string | null | undefined>;
  labelById?: (id: string) => string | null;
}): string | null {
  const parts: string[] = [];
  const generalNote = getWodRxNote(args.methodMeta);
  if (generalNote) parts.push(generalNote);

  const loads = getWodRxLoads(args.methodMeta);
  const orderedIds = Array.isArray(args.exerciseIds) ? args.exerciseIds : [];
  const seen = new Set<string>();
  const loadParts: string[] = [];

  for (const rawId of orderedIds) {
    const id = String(rawId ?? '').trim();
    if (!id || seen.has(id)) continue;
    seen.add(id);
    const load = loads[id];
    if (!load) continue;
    const label = args.labelById?.(id) ?? null;
    loadParts.push(label ? `${label}: ${load}` : load);
  }

  for (const [id, load] of Object.entries(loads)) {
    if (seen.has(id)) continue;
    const label = args.labelById?.(id) ?? null;
    loadParts.push(label ? `${label}: ${load}` : load);
  }

  if (loadParts.length) {
    parts.push(`Rx loads: ${loadParts.join('; ')}`);
  }

  return parts.length ? parts.join(' | ') : null;
}
